import type { TagSuggestion } from '../api/files'
import type { DocType } from '../utils/docTypes'
import DocTypeChipFilter from './DocTypeChipFilter'
import TagInput from './TagInput'

export interface SearchFiltersProps {
  docTypes: DocType[]
  onDocTypesChange: (docTypes: DocType[]) => void
  tags: string[]
  onTagsChange: (tags: string[]) => void
  tagSuggestions: TagSuggestion[]
  disabled?: boolean
  onInfer?: () => void
  isInferring?: boolean
  inferredNote?: string | null
}

export default function SearchFilters({
  docTypes,
  onDocTypesChange,
  tags,
  onTagsChange,
  tagSuggestions,
  disabled = false,
  onInfer,
  isInferring = false,
  inferredNote = null,
}: SearchFiltersProps) {
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <label className="block text-sm font-medium text-harbor-text-secondary">
          Document types{' '}
          <span className="text-xs text-harbor-text-muted font-normal">(any-of; none = all)</span>
        </label>
        {onInfer && (
          <button
            type="button"
            onClick={onInfer}
            disabled={disabled || isInferring}
            className="px-3 py-1 text-xs font-medium rounded-lg bg-harbor-surface-raised border border-harbor-border text-emerald-300 hover:border-emerald-500 disabled:opacity-50"
          >
            {isInferring ? 'Inferring…' : '✨ Infer filters'}
          </button>
        )}
      </div>
      <DocTypeChipFilter value={docTypes} onChange={onDocTypesChange} disabled={disabled} />
      <div className="max-w-md">
        <label className="block text-sm font-medium text-harbor-text-secondary mb-1">
          Tags{' '}
          <span className="text-xs text-harbor-text-muted font-normal">(any-of; none = all)</span>
        </label>
        <TagInput
          value={tags}
          onChange={onTagsChange}
          suggestions={tagSuggestions}
          disabled={disabled}
          placeholder="Filter by tags…"
        />
      </div>
      {inferredNote && <p className="text-xs text-harbor-text-muted">{inferredNote}</p>}
    </div>
  )
}
